function Logos(_size: number) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
			<g clip-path="url(#clip0_10844_27697)">
				<path
					d="M6.03809 4.45703C6.03809 4.16579 6.27419 3.92969 6.56543 3.92969H12.4355C12.7268 3.92969 12.9629 4.16579 12.9629 4.45703C12.9629 4.74828 12.7268 4.98438 12.4355 4.98438H6.56543C6.27419 4.98438 6.03809 4.74828 6.03809 4.45703Z"
					fill="#5B5B5B"
				/>
				<path
					d="M6.03809 4.45703C6.03809 4.16579 6.27419 3.92969 6.56543 3.92969H12.4355C12.7268 3.92969 12.9629 4.16579 12.9629 4.45703C12.9629 4.74828 12.7268 4.98438 12.4355 4.98438H6.56543C6.27419 4.98438 6.03809 4.74828 6.03809 4.45703Z"
					fill="black"
					fill-opacity="0.2"
				/>
				<path
					d="M6.03809 14.1719C6.03809 13.8806 6.27419 13.6445 6.56543 13.6445H12.4355C12.7268 13.6445 12.9629 13.8806 12.9629 14.1719C12.9629 14.4631 12.7268 14.6992 12.4355 14.6992H6.56543C6.27419 14.6992 6.03809 14.4631 6.03809 14.1719Z"
					fill="#5B5B5B"
				/>
				<path
					d="M6.03809 14.1719C6.03809 13.8806 6.27419 13.6445 6.56543 13.6445H12.4355C12.7268 13.6445 12.9629 13.8806 12.9629 14.1719C12.9629 14.4631 12.7268 14.6992 12.4355 14.6992H6.56543C6.27419 14.6992 6.03809 14.4631 6.03809 14.1719Z"
					fill="black"
					fill-opacity="0.2"
				/>
				<path
					d="M6.94467 11.2521C6.1229 11.2521 5.45435 10.7306 5.45435 10.0896V8.53745C5.45435 7.89647 6.1229 7.375 6.94467 7.375C7.76644 7.375 8.435 7.89647 8.435 8.53745V10.0896C8.435 10.7306 7.76644 11.2521 6.94467 11.2521ZM6.94467 8.14785C6.66923 8.14785 6.44514 8.32263 6.44514 8.53748V10.0896C6.44514 10.3045 6.66923 10.4793 6.94467 10.4793C7.22011 10.4793 7.4442 10.3045 7.4442 10.0896V8.53748C7.4442 8.32263 7.22011 8.14785 6.94467 8.14785Z"
					fill="#5B5B5B"
				/>
				<path
					d="M6.94467 11.2521C6.1229 11.2521 5.45435 10.7306 5.45435 10.0896V8.53745C5.45435 7.89647 6.1229 7.375 6.94467 7.375C7.76644 7.375 8.435 7.89647 8.435 8.53745V10.0896C8.435 10.7306 7.76644 11.2521 6.94467 11.2521ZM6.94467 8.14785C6.66923 8.14785 6.44514 8.32263 6.44514 8.53748V10.0896C6.44514 10.3045 6.66923 10.4793 6.94467 10.4793C7.22011 10.4793 7.4442 10.3045 7.4442 10.0896V8.53748C7.4442 8.32263 7.22011 8.14785 6.94467 8.14785Z"
					fill="black"
					fill-opacity="0.2"
				/>
				<path d="M5.25111 11.252H3.26538V7.375H4.25618V10.4792H5.25111V11.252Z" fill="#5B5B5B" />
				<path
					d="M5.25111 11.252H3.26538V7.375H4.25618V10.4792H5.25111V11.252Z"
					fill="black"
					fill-opacity="0.2"
				/>
				<path
					d="M10.5941 11.2521C9.77232 11.2521 9.10376 10.7306 9.10376 10.0896V8.53745C9.10376 7.89647 9.77232 7.375 10.5941 7.375C11.4159 7.375 12.0844 7.89647 12.0844 8.53745H11.0936C11.0936 8.32261 10.8695 8.14782 10.5941 8.14782C10.3186 8.14782 10.0946 8.32263 10.0946 8.53748V10.0896C10.0946 10.3045 10.3186 10.4793 10.5941 10.4793C10.8695 10.4793 11.0936 10.3045 11.0936 10.0896V9.69995H10.5941V8.92713H12.0844V10.0896C12.0844 10.7306 11.4159 11.2521 10.5941 11.2521Z"
					fill="#5B5B5B"
				/>
				<path
					d="M10.5941 11.2521C9.77232 11.2521 9.10376 10.7306 9.10376 10.0896V8.53745C9.10376 7.89647 9.77232 7.375 10.5941 7.375C11.4159 7.375 12.0844 7.89647 12.0844 8.53745H11.0936C11.0936 8.32261 10.8695 8.14782 10.5941 8.14782C10.3186 8.14782 10.0946 8.32263 10.0946 8.53748V10.0896C10.0946 10.3045 10.3186 10.4793 10.5941 10.4793C10.8695 10.4793 11.0936 10.3045 11.0936 10.0896V9.69995H10.5941V8.92713H12.0844V10.0896C12.0844 10.7306 11.4159 11.2521 10.5941 11.2521Z"
					fill="black"
					fill-opacity="0.2"
				/>
				<path
					d="M14.2435 11.2521C13.4217 11.2521 12.7532 10.7306 12.7532 10.0896V8.53745C12.7532 7.89647 13.4217 7.375 14.2435 7.375C15.0653 7.375 15.7338 7.89647 15.7338 8.53745V10.0896C15.7338 10.7306 15.0653 11.2521 14.2435 11.2521ZM14.2435 8.14785C13.9681 8.14785 13.744 8.32263 13.744 8.53748V10.0896C13.744 10.3045 13.9681 10.4793 14.2435 10.4793C14.5189 10.4793 14.743 10.3045 14.743 10.0896V8.53748C14.743 8.32263 14.5189 8.14785 14.2435 8.14785Z"
					fill="#5B5B5B"
				/>
				<path
					d="M14.2435 11.2521C13.4217 11.2521 12.7532 10.7306 12.7532 10.0896V8.53745C12.7532 7.89647 13.4217 7.375 14.2435 7.375C15.0653 7.375 15.7338 7.89647 15.7338 8.53745V10.0896C15.7338 10.7306 15.0653 11.2521 14.2435 11.2521ZM14.2435 8.14785C13.9681 8.14785 13.744 8.32263 13.744 8.53748V10.0896C13.744 10.3045 13.9681 10.4793 14.2435 10.4793C14.5189 10.4793 14.743 10.3045 14.743 10.0896V8.53748C14.743 8.32263 14.5189 8.14785 14.2435 8.14785Z"
					fill="black"
					fill-opacity="0.2"
				/>
				<rect
					x="1.50146"
					y="1.3125"
					width="16"
					height="16"
					rx="4"
					stroke="currentColor"
					stroke-width="1.25"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<rect
					x="1.50146"
					y="1.3125"
					width="16"
					height="16"
					rx="4"
					stroke="currentColor"
					stroke-opacity="0.2"
					stroke-width="1.25"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10844_27697">
					<rect width="18" height="18" fill="currentColor" transform="translate(0.5 0.3125)" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default Logos;
